var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded box-border pa-4 mb-5",class:{
    'box-border-brandPrimary': _vm.isSelected,
    'hover-box cursor-pointer': _vm.isClickable,
  },on:{"click":_vm.handleClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }